﻿/**
 * Auto and Manual Tile Blocks
 *
 *  based on BootStrap Cards
 *
 * @class rlTileBlocks
 * @memberOf jQuery.fn
 */

(function($) {
    $.fn.rlTileBlocks = function () {
        const readAtag = $('section.manualtile span.read a'),
            titleAtag = $('section.manualtile .head-link'),
            manualSelectors = $('section.manualtile span.read a, section.manualtile .head-link'),
            manualParent = 'section.manualtile',
            spanRead = 'span.read',
            cardBody = '.card-body';

        //create tile block line animation
        readAtag.hover(function () {
            $(this).parent(spanRead).next('span.line').toggleClass('hover');
        });
        readAtag.focusin(function () {
            $(this).parent(spanRead).next('span.line').addClass('hover');
        });
        readAtag.focusout(function () {
            $(this).parent(spanRead).next('span.line').removeClass('hover');
        });

        //create parent hover state
        manualSelectors.hover(function () {
            $(this).parents(manualParent).toggleClass('is-hovered');
        });
        manualSelectors.focusin(function () {
            $(this).parents(manualParent).addClass('is-hovered');
        });
        manualSelectors.focusout(function () {
            $(this).parents(manualParent).removeClass('is-hovered');
        });

        //title link triggers cta animation
        titleAtag.hover(function () {
            if ($(this).parents(cardBody).find('.tile-button').length > 0) {
                $(this).parents(cardBody).find('.tile-button').toggleClass('hover'); // linkButtonStyle true
            }
            else {
                $(this).parents(cardBody).find('span.line').toggleClass('hover'); //linkButtonStyle false
                $(this).parents(cardBody).find('span.read').find('a').toggleClass('hover');
            }
        });

        //layout polyfills
        function linkButtonPadding() {
            $('section.manualtile, section.autotile').each(function () {
                const oneline = 20,
                    parentPadBot = 110,
                    oneButton = 56,
                    findButton = $(this).find('.tile-button');

                if (findButton.length > 0 && findButton.height() >= oneline) {
                    let multilineButton = (parentPadBot - oneButton) + findButton.innerHeight(),
                        roundedButton = Math.round(multilineButton);

                    $(this).find(cardBody).css('padding-bottom', roundedButton);
                }
            });
        }

        linkButtonPadding();

        $(window).on('resize-end', function () {
            linkButtonPadding();
        });

        //MatchHeight Tile Blocks that sit side by side
        $('.autotileblock .card, .manualtileblock .card, .campaignblock .card, .placeholderblock .card, .literaturelibraryblock .card').matchHeight();

    }
}(jQuery));